module.exports = __webpack_public_path__ + "./rules/Regulament-pariuri.a4613b262ef89bfec21946c04784c353.pdf";